module.exports = __webpack_public_path__ + "media/components/country-flag/static/il-9d5f2209468e42e387d6c6a5740b8977.svg";